export default class AuthCodeProvider {
    static get Sms () { return 'sms' }
    static get FlashCall () { return 'flash-call' }

    static getName (enumValue) {
      switch (enumValue) {
        case this.Sms:
          return 'SMS'
        case this.FlashCall:
          return 'Звонок на номер (Flash-call)'
        default:
          return enumValue
      }
    }

    static getAllVariants () {
      const variants = [
        this.Sms,
        this.FlashCall,
      ]

      return variants.map(item => ({
        value: item,
        name: this.getName(item),
      }))
    }

    static getValidationDescription (enumValue) {
      switch (enumValue) {
        case this.Sms:
          return 'Введите код из СМС'
        case this.FlashCall:
          return 'Введите последние 4 цифры номера телефона с которого поступил звонок'
        default:
          return 'Введите полученный код'
      }
    }
  }
